export default {"src":"/_next/static/media/24-icon.684ae481.svg","height":46,"width":35,"blurWidth":0,"blurHeight":0};